<template>
  <div class="settled">
    <headd :mobile_title="mobile_title"></headd>
    <div class="kv">
      <img src="../../static/twitter/banner.png" />
    </div>
    <div class="formbox container">
      <div class="box_title">填写信息</div>
      <div class="dbox_cell">
        <div class="dbox_name">姓名</div>
        <div class="dbox_input">
          <input
            type="text"
            v-model="customers.name"
            placeholder="请输入"
            class="input"
          />
        </div>
      </div>
      <div class="dbox_cell">
        <div class="dbox_name">手机号码</div>
        <div class="dbox_input">
          <input
            type="text"
            v-model="customers.tel"
            maxlength="11"
            placeholder="请输入"
            class="input"
          />
        </div>
      </div>

      <div class="dbox_cell">
        <div class="dbox_name">选择服务</div>
        <div class="dbox_input">
          <div class="select">
            <select
              v-model="serviceSelected"
              @change="getserviceSelected($event)"
            >
              <option v-for="item in service" :key="item" :value="item">{{
                item
              }}</option>
            </select>
            <!-- <img src="../../static/user/icon_10.png" class="icon" /> -->
          </div>
        </div>
      </div>
      <div class="dbox_cell" v-if="customers.service == '其他服务'">
        <div class="dbox_name">其他服务</div>
        <div class="dbox_input">
          <textarea
            class="textarea"
            v-model="customers.otherdesc"
            placeholder="请填写您需要的其他服务"
          ></textarea>
        </div>
      </div>

      <div class="btn_save" @click="btn_save">立即推荐</div>
    </div>
    <foot></foot>
  </div>
</template>

<script>
import headd from "@/components/head";
import foot from "@/components/foot";
import { getreferCustomers } from "./api/api"; //引入api里面定义的方法
export default {
  data() {
    return {
      mobile_title: "推客",
      serviceSelected: "请选择",
      customers: {
        name: "",
        tel: "",
        service: ""
      },
      index: 0,
      service: [
        "请选择",
        "公司注册",
        "代理记账",
        "商标注册",
        "知识产权",
        "许可证办理",
        "公司服务",
        "医疗器械许可",
        "其他服务"
      ]
    };
  },
  metaInfo: {
    title: "马上创业网 专注企业注册的网站", // set a title
    meta: [
      {
        // set meta
        name: "keyWords",
        content:
          "马上创业网，注册公司，代理记账，上海注册公司，注册公司流程，注册公司费用，商标注册，法务咨询，法律服务，个体工商户注册，许可证办理，专业法律，社保，公积金，专利申请，医疗器械许可证，ICP电信增值许可证，食品经营许可证，酒类经营许可证，餐饮服务许可证，道路运输许可证，广播电视节目许可证，海关资质，进出口许可证，商标设计，logo设计，VI设计，海报设计，包装设计，APP开发，微信运营，网站定制，版权服务，软件著作权，发明专利，外观设计专利，实用新型专利，商标转让，驳回复审，注销公司，股权变更，经营范围变更，股权协议，股权转让，劳务派遣"
      },
      {
        name: "description",
        content:
          "马上创业网是一个专为中小企业服务的综合平台，主要提供医疗器械服务、审计服务、知识产权服务、财税咨询、注册公司、代理记账、商标注册、专利申请、社保代理、法务代理等一站式的服务，借助移动互联网技术，改善并升级企业服务状态，实现了新形势下中小企业所需要的企业服务。"
      }
    ]
  },
  components: {
    headd,
    foot
  },
  methods: {
    getserviceSelected(e) {
      var _self = this;
      _self.customers.service = e.target.value;
    },
    async btn_save() {
      var _self = this;
      var data = _self.customers;
      var phone_reg = /^1[3456789]\d{9}$/;
      //console.log(data);
      if (data.name == "") {
        this.$toast("请输入名字");

        return false;
      }
      if (data.tel == "") {
        this.$toast("请输入电话");

        return false;
      } else {
        if (!phone_reg.test(data.tel)) {
          this.$toast("手机号码格式错误");

          return false;
        }
      }
      if (data.service == "") {
        this.$toast("请选择服务");

        return false;
      }

      var parm = {
        uid: localStorage.getItem("userId"),
        tel: data.tel,
        name: data.name,
        otherdesc: data.otherdesc,
        service: data.service
      };

      const res = await getreferCustomers(parm);
      if (res.status == 1) {
        this.$toast({
          message: "提交成功",
          type: "success"
        });
        _self.customers = {};
        _self.serviceSelected = "请选择";
      }
    },
    gettel(e) {
      var that = this;
      that.setValue(e.detail.value, "tel");
    },
    getname(e) {
      var that = this;
      that.setValue(e.detail.value, "name");
    },
    getotherdesc(e) {
      var that = this;
      that.setValue(e.detail.value, "otherdesc");
    },
    setValue(v, key) {
      var that = this;
      var tmpData = that.customers;
      tmpData[key] = v;
      that.customers = tmpData;
    },
    bindPickerChange(e) {
      var _self = this;
      var index = e.detail.value;
      console.log(e);
      _self.index = index;
      if (index > 0) {
        _self.customers.service = _self.service[index];
      }
    }
  }
};
</script>

<style lang="less" scoped>
page {
  background-color: #f2f2f2;
}
.settled {
  flex-direction: column;
  width: 100%;

  .kv {
    width: 100%;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .formbox {
    width: 8rem;
    @media (max-width: 991px) {
      margin: 0.3rem 0.32rem;
      width: 6.86rem !important;
    }
  }
}
.box_title {
  @media (max-width: 991px) {
    font-size: 0.38rem;
    line-height: 0.38rem;
    margin-bottom: 0.4rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/twitter.vue